import { render } from "storyblok-rich-text-react-renderer";
import type { SbEditableComponentProps } from "types/storyblok";
import type { RichtextAdapterProps } from "./RichtextAdapter.d";
import { isEmpty } from "./utils";
import { DefaultBlokResolver, getMarkResolvers, getNodeResolvers } from "./utils/getResolvers";

const RichtextAdapter = ({
  content,
  customStyles = {},
  sbEditable,
}: SbEditableComponentProps<RichtextAdapterProps>) => {
  if (isEmpty(content)) return null;

  return render(content, {
    nodeResolvers: getNodeResolvers({ customStyles, sbEditable }),
    markResolvers: getMarkResolvers({ customStyles }),
    defaultBlokResolver: DefaultBlokResolver,
  });
};

export default RichtextAdapter;
